import { message, Upload } from "antd";
import Sha256Encode from "../../../components/sha256";
import { useEffect, useState } from "react";

export default function KnowledgeUploader({ type, value, onChange, children, multiUpload, maxSize, ossData, ...props }: any) {
    const [OSSData, setOSSData] = useState<any>(ossData);

    useEffect(() => {
        if (ossData && JSON.stringify(ossData) !== JSON.stringify(OSSData)) {
            setOSSData(ossData);
        }
    }, [ossData, OSSData]);

    const handleChange = async ({ fileList }: any) => {
        if (!multiUpload) {
            // 上传单个文件，只处理第一个file对象
            const [file] = fileList;
            if (!file) {
                onChange?.([]);
                return;
            }
            // 对于单个文件上传，确保文件始终在列表中
            if (file.status === 'uploading') {
                // 上传中状态，直接更新列表
                onChange?.(fileList);
            } else if (file.status === 'done') {
                // 上传完成，设置URL并更新列表
                setFileUrl(file);
                onChange?.(fileList);
            } else {
                // 其他状态也更新列表
                onChange?.(fileList);
            }
            return;
        }
        // 只处理本次新增的已完成文件，避免重复处理
        const promises = fileList.map(async (item: any) => {
            // 只处理状态为done且尚未处理的文件
            if (item.status === "done" && !item.originUrl) {
                // 添加防重标记，防止其他handleChange实例重复处理
                if (!item._processing) {
                    item._processing = true;
                    try {
                        setFileUrl(item);
                    } finally {
                        delete item._processing;
                    }
                }
            }
            return item;
        });

        // 等待所有处理完成
        await Promise.all(promises);

        // 只有当所有文件都处理完成时才触发onChange
        const allDone = fileList.every((item: any) =>
            item.status === "done" || item.status === "error"
        );

        if (allDone) {
            onChange?.(fileList);
        }
    };

    const setFileUrl = (file: any) => {
        file.url = `${OSSData.host}/${file.url}`;
    };

    const onRemove = (file: any) => {
        // if (onChange) {
        //     onChange(files);
        // }
    };

    const getExtraData = (file: any) => {
        return {
            key: file.url,
            OSSAccessKeyId: OSSData?.keyId,
            policy: OSSData?.policy,
            Signature: OSSData?.signature,
        };
    };

    const beforeUpload = async (file: any) => {
        if (maxSize) {
            // 校验文件大小，如果文件大小超过maxSize，则return
            if (file.size > maxSize * 1024 * 1024) {
                message.error(`文件大小不能超过${maxSize}MB，请重新上传`);
                return Upload.LIST_IGNORE;
            }
        }
        if (!OSSData) return false;
        const file_content = await file.arrayBuffer();
        const file_name = await Sha256Encode(file_content);
        const extension = getFileExtension(file.name);
        file.url = [OSSData?.dir, `${file_name}${extension}`].join("/");
        return file;
    };

    const getFileExtension = (fileName: string) => {
        const parts = fileName.split(".");
        return parts.length > 1 ? `.${parts.pop()}` : "";
    };

    const uploadProps = {
        // name: 'file',
        fileList: value,
        action: OSSData?.host,
        onChange: handleChange,
        onRemove,
        data: getExtraData,
        beforeUpload,
    };

    return (
        <Upload {...props} {...uploadProps}>
            {children}
        </Upload>
    );
};
